var map = {
	"./ar.json": 5310,
	"./bg.json": 44378,
	"./ca.json": 78109,
	"./cs.json": 83571,
	"./da.json": 49914,
	"./de.json": 95894,
	"./el.json": 94524,
	"./en.json": 44174,
	"./eo.json": 30537,
	"./es.json": 46725,
	"./fa.json": 93248,
	"./fi.json": 46808,
	"./fr.json": 94605,
	"./gl.json": 4346,
	"./he.json": 26282,
	"./hr.json": 36759,
	"./hu.json": 86938,
	"./id.json": 35176,
	"./it.json": 83672,
	"./ja.json": 87980,
	"./ko.json": 19423,
	"./nb.json": 49093,
	"./nl.json": 34943,
	"./pl.json": 11029,
	"./pt-BR.json": 46040,
	"./pt.json": 37741,
	"./ru.json": 74600,
	"./sl.json": 37110,
	"./sv.json": 28252,
	"./ta.json": 77610,
	"./th.json": 67549,
	"./ti.json": 83570,
	"./tr.json": 79755,
	"./uk.json": 92749,
	"./vi.json": 91496,
	"./zh-Hans.json": 94742,
	"./zh-Hant.json": 63531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35679;